// Disable return types for import functions
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/** See https://router.vuejs.org/fr/essentials/navigation.html for help */
export const routesSspa = [
	{
		path: '/qrp/',
		name: 'onglets',
		props: true,
		component: () => import(
			/* webpackChunkName: "employeur" */
			'@/views/onglets/Onglets.vue'
			),
		meta: {
			logged: true
		},
		children: [
			{
				path: '/qrp/employeur/dossiers',
				name: 'dossierEmployeur',
				component: () => import(
					/* webpackChunkName: "dossierEmployeur" */
					'@/views/dossiers/DossierEmployeur.vue'
					),
				meta: {
					logged: true,
					breadcrumb: [
						// dossierEmployeur redirige vers le bon composant en fonction du type d'utilisateur
						{ text: 'Questionnaire Risques Professionnel', to: { name: 'dossierEmployeur' } }
					]
				}
			},
			{
				path: '/qrp/details-dossier/:dossierId',
				name: 'detailsDossier',
				props: true,
				component: () => import(
					/* webpackChunkName: "detailsDossier" */
					'@/views/DetailsDossier.vue'
					),
				meta: {
					logged: true,
					breadcrumb: [
						// dossierEmployeur redirige vers le bon composant en fonction du type d'utilisateur
						{ text: 'Questionnaire Risques Professionnel', to: { name: 'dossierEmployeur' } },
						{ text: 'Détails du dossier' }
					]
				}
			}
		]
	},
	{
		path: '/qrp/questionnaire/:reponseId/:dossierId?',
		name: 'questionnaire',
		component: () => import(
			/* webpackChunkName: "questionnaire" */
			'@/views/Questionnaire.vue'
			),
		props: true,
		meta: {
			logged: true,
			breadcrumb: [
				// dossierEmployeur redirige vers le bon composant en fonction du type d'utilisateur
				{ text: 'Questionnaire Risques Professionnel', to: { name: 'dossierEmployeur' } },
				{ text: 'Détails du dossier', to: 'detailsDossier' },
				{ text: 'Questionnaire' }
			]
		}
	},
	{
		path: '/qrp/maintenance',
		name: 'maintenance',
		component: () => import(
			/* webpackChunkName: "maintenance" */
			'@/views/Maintenance.vue'
			),
		meta: {
			logged: true
		}
	},
	{
		path: '*', // Everything that doesn't match a route
		name: 'notFound',
		component: () => import(
			/* webpackChunkName: "not-found" */
			'@/views/NotFound.vue'
			),
		meta: {
			logged: false
		}
	}
];
